"use strict";exports.__esModule = true;exports.getCommonVisualStateDataAttributes = getCommonVisualStateDataAttributes;
var _getVisualStateDataAttributes = require("./getVisualStateDataAttributes");
var _tryGetBoolean = require("./tryGetBoolean");

function getCommonVisualStateDataAttributes(
componentProps)
{
  return (0, _getVisualStateDataAttributes.getVisualStateDataAttributes)({
    error: (0, _tryGetBoolean.tryGetBoolean)(componentProps['error']),
    warning: (0, _tryGetBoolean.tryGetBoolean)(componentProps['warning'])
  });
}